export enum UiComponentType {
  CARD = 'card',
  BANNER = 'banner',
  SLIDER = 'slider',
}
